import { styled, Theme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/system";
import { ObjectId } from "bson";
import { GetServerSidePropsContext } from "next";
import { useRouter } from "next/router";
import React from "react";
import { connect } from "react-redux";
import SearchDesktopLayoutSkeleton from "../../../components/cards/skeletonLoadingCard/SearchDesktopLayoutSkeleton";
import Layout from "../../../components/layout-components/Layout";
import FilterComponents from "../../../components/ppsf/FilterComponents";
import { validateClientSession } from "../../../lib/auth/helpers";
import authenticationTokenGenerator from "../../../lib/authentication_token_generator";
import handleDatabaseConnection from "../../../lib/handleDatabaseConnection";
import RouterQuerySearchFilters from "../../../lib/RouterQuerySearchFilters";
import storeUTMSource from "../../../lib/storeUTMSource";
import {
	PrePackagedSearchFiltersInterface,
	PrePackagedSearchFiltersModel,
	PropertyModel,
	UsersModel,
} from "../../../models";
import StateInterface from "../../../redux-magic/state-interface";
import { updateReduxSessionThunk, wrapper } from "../../../redux-magic/store";
import { bottom_subscribe_buy_beegru_points } from "../../../redux-magic/sub-state-data-empty/bottom-subscribe-buy-beegru-points";
import { chat_states } from "../../../redux-magic/sub-state-data-empty/chat-states";
import { notifications_page } from "../../../redux-magic/sub-state-data-empty/notifications-page";

export const getServerSideProps = wrapper.getServerSideProps(
	(store: any) => async (context: GetServerSidePropsContext) => {
		const server_session: any = await authenticationTokenGenerator(context);
		const utm_source: string | null = context
			? context.query
				? context.query.utm_source
					? context.query.utm_source.toString().length > 0
						? context.query.utm_source.toString()
						: null
					: null
				: null
			: null;

		const utm_source_id: string | null = context
			? context.query
				? context.query.utm_source_id
					? context.query.utm_source_id.toString().length > 0
						? context.query.utm_source_id.toString()
						: null
					: null
				: null
			: null;

		const simple_campaign_id = new ObjectId();

		if (!!utm_source && !!utm_source_id) {
			await storeUTMSource(utm_source, utm_source_id, simple_campaign_id);
		}
		const route: string = context
			? context.query
				? context.query.route
					? context.query.route.toString().length > 0
						? context.query.route.toString()
						: "default"
					: "default"
				: "default"
			: "default";

		if (!route || route === "default") {
			let label = "HSR Layout";
			let lat = 12.9121181;
			let lon = 77.6445548;
			const callbackUrl = encodeURIComponent(
				`${process.env.PRODUCTION_URL}search?search_type=properties&location=${label},${lat},${lon}&transaction_type=rent&property_category=residential&property_type=Apartment&locale=${context.locale || "en-IN"}`,
			);

			return {
				redirect: {
					destination: `${process.env.PRODUCTION_URL}loading.html?callbackUrl=${callbackUrl}`,
					permanent: false,
				},
			};
		}

		let properties: any = [];
		let AndMatchStatements: Array<{ [key: string]: any }> = [];
		let AndMatchStatementsUnfiltered: any = [];
		let location: any = {};
		let ppsfDetails: any = {};
		let ppsf: any = {};


		if (route !== "default") {
			try {
				await handleDatabaseConnection(true);
				const randomPlaceholderObjectId: ObjectId = new ObjectId();
				const currentDate: Date = new Date();
				ppsf = (
					await PrePackagedSearchFiltersModel.findOne({
						route: route,
						enable: true,
						is_deleted: false,
					})
				)?.toObject() || {
					_id: randomPlaceholderObjectId.toString(),
					friendly_id: "",
					created_by: randomPlaceholderObjectId.toString(),
					route: route,
					location: null,
					search_type: null,
					transaction_type: null,
					property_category: null,
					property_type: null,
					budget: null,
					security_deposit: null,
					bhk: null,
					bathroom: null,
					balconies: null,
					area: null,
					seats: null,
					plot_dimensions: null,
					availability: null,
					possession_date: null,
					available_from: null,
					unit_facing: null,
					land_facing: null,
					floors: null,
					furnished: null,
					amenities: null,
					service_category: null,
					service_type: null,
					service_subtype: null,
					listedBy: null,
					business_profile_type: null,
					select_query: {
						collection: "",
						selectQueries: {},
					},
					meta_title: "",
					meta_description: "",
					h1: "",
					h2: "",
					enable: true,
					tags: [],
					is_deleted: false,
					deleted_at: currentDate.toString(),
					created_at: currentDate.toString(),
					updated_at: currentDate.toString(),
				};


				location = ppsf.location as any;

				const cby: any = (
					await UsersModel.findOne(
						{ _id: ppsf.created_by },
						{
							_id: 1,
							first_name: 1,
							last_name: 1,
						},
					)
				)?.toObject() || {
					first_name: "Unknown",
					last_name: "User",
				};


				ppsfDetails = Object.keys(ppsf)
					.filter((ppsfKey: string) =>
						[
							"_id",
							"friendly_id",
							"created_by",
							"route",
							"created_at",
							"updated_at",
							"enable",
							"tags",
							"deleted_at",
							"is_deleted",
							"meta_title",
							"meta_description",
							"h1",
							"h2",
						].includes(ppsfKey),
					)
					.map((ppsfKey: string, ppsfKeyIndex: number) => {
						switch (ppsfKey) {
							case "_id":
								return {
									key: "PPSF ID",
									value: ppsf[ppsfKey],
								};
							case "friendly_id":
								return {
									key: "Friendly ID",
									value: ppsf[ppsfKey],
								};
							case "created_by":
								return {
									key: "Created By",
									value: {
										_id: cby._id,
										first_name: cby.first_name,
										last_name: cby.last_name,
									},
								};
							case "route":
								return {
									key: "Route",
									value: ppsf[ppsfKey],
								};
							case "created_at":
								return {
									key: "Created At",
									value: new Date(ppsf[ppsfKey]).toUTCString(),
								};
							case "updated_at":
								return {
									key: "Updated At",
									value: new Date(ppsf[ppsfKey]).toUTCString(),
								};
							case "enable":
								return {
									key: "Enabled",
									value: ppsf[ppsfKey] ? "Yes" : "No",
								};
							case "tags":
								return {
									key: "Tags",
									value: ppsf[ppsfKey].join(", "),
								};
							case "deleted_at":
								return {
									key: "Deleted At",
									value: new Date(ppsf[ppsfKey]).toUTCString(),
								};
							case "is_deleted":
								return {
									key: "Is Deleted",
									value: ppsf[ppsfKey] ? "Yes" : "No",
								};
							case "meta_title":
								return {
									key: "Meta Title",
									value: ppsf[ppsfKey],
								};
							case "meta_description":
								return {
									key: "Meta Description",
									value: ppsf[ppsfKey],
								};
							case "h1":
								return {
									key: "Page Title (H1 Tag)",
									value: ppsf[ppsfKey],
								};
							case "h2":
								return {
									key: "Page Subtitle / Description (H2 Tag)",
									value: ppsf[ppsfKey],
								};
							default:
								return {
									key: ppsfKey,
									value: ppsf[ppsfKey as keyof PrePackagedSearchFiltersInterface],
								};
						}
					});

				const select_queries: { [key: string]: any } =
					ppsf.select_query.collection === "services"
						? Object.keys(ppsf.select_query.selectQueries)
								.filter((key: string) => ["service_category", "service_type", "service_subtype"].includes(key))
								.reduce((acc: { [key: string]: any }, key: string) => {
									acc[key] = ppsf.select_query.selectQueries[key];
									return acc;
								}, {})
						: Object.keys(ppsf.select_query.selectQueries)
								.filter((key: string) => !["service_category", "service_type", "service_subtype"].includes(key))
								.reduce((acc: { [key: string]: any }, key: string) => {
									acc[key] = ppsf.select_query.selectQueries[key];
									return acc;
								}, {});

				AndMatchStatementsUnfiltered = [
					{ transaction_type: select_queries["transaction_type"] || null },
					{ property_category: select_queries["property_category"] || null },
					{ property_type: select_queries["property_type"] || null },
					{ "price.min": select_queries["price.min"] || null },
					{ "price.max": select_queries["price.max"] || null },
					{ "security_deposit.min": select_queries["security_deposit.min"] || null },
					{ "security_deposit.max": select_queries["security_deposit.max"] || null },
					{ "bhk.min": select_queries["bhk.min"] || null },
					{ "bhk.max": select_queries["bhk.max"] || null },
					{ "bathroom.min": select_queries["bathroom.min"] || null },
					{ "bathroom.max": select_queries["bathroom.max"] || null },
					{ "balconies.min": select_queries["balconies.min"] || null },
					{ "balconies.max": select_queries["balconies.max"] || null },
					{ "area.super_built_up_area.min.ft": select_queries["area.super_built_up_area.min.ft"] || null },
					{ "area.super_built_up_area.max.ft": select_queries["area.super_built_up_area.max.ft"] || null },
					{ "seats.min": select_queries["seats.min"] || null },
					{ "seats.max": select_queries["seats.max"] || null },
					{ plot_dimensions: select_queries["plot_dimensions"] || null },
					{ availability: select_queries["availability"] || null },
					{ possession_date: select_queries["possession_date"] || null },
					{ available_from: select_queries["available_from"] || null },
					{ unit_facing: select_queries["unit_facing"] || null },
					{ land_facing: select_queries["land_facing"] || null },
					{ floors: select_queries["floors"] || null },
					{ furnished: select_queries["furnished"] || null },
					{ amenities: select_queries["amenities"] || null },
					{ service_category: select_queries["service_category"] || null },
					{ service_type: select_queries["service_type"] || null },
					{ service_subtype: select_queries["service_subtype"] || null },
					{ listedBy: select_queries["listedBy"] || null },
					{ business_profile_type: select_queries["business_profile_type"] || null },
				];
				AndMatchStatements = [
					{ transaction_type: select_queries["transaction_type"] || null },
					{ property_category: select_queries["property_category"] || null },
					{ property_type: select_queries["property_type"] || null },
					{ "price.min": select_queries["price.min"] || null },
					{ "price.max": select_queries["price.max"] || null },
					{ "security_deposit.min": select_queries["security_deposit.min"] || null },
					{ "security_deposit.max": select_queries["security_deposit.max"] || null },
					{ "bhk.min": select_queries["bhk.min"] || null },
					{ "bhk.max": select_queries["bhk.max"] || null },
					{ "bathroom.min": select_queries["bathroom.min"] || null },
					{ "bathroom.max": select_queries["bathroom.max"] || null },
					{ "balconies.min": select_queries["balconies.min"] || null },
					{ "balconies.max": select_queries["balconies.max"] || null },
					{ "area.super_built_up_area.min.ft": select_queries["area.super_built_up_area.min.ft"] || null },
					{ "area.super_built_up_area.max.ft": select_queries["area.super_built_up_area.max.ft"] || null },
					{ "seats.min": select_queries["seats.min"] || null },
					{ "seats.max": select_queries["seats.max"] || null },
					{ plot_dimensions: select_queries["plot_dimensions"] || null },
					{ availability: select_queries["availability"] || null },
					{ possession_date: select_queries["possession_date"] || null },
					{ available_from: select_queries["available_from"] || null },
					{ unit_facing: select_queries["unit_facing"] || null },
					{ land_facing: select_queries["land_facing"] || null },
					{ floors: select_queries["floors"] || null },
					{ furnished: select_queries["furnished"] || null },
					{ amenities: select_queries["amenities"] || null },
					{ service_category: select_queries["service_category"] || null },
					{ service_type: select_queries["service_type"] || null },
					{ service_subtype: select_queries["service_subtype"] || null },
					{ listedBy: select_queries["listedBy"] || null },
					{ business_profile_type: select_queries["business_profile_type"] || null },
				].filter((and_match_statement: { [key: string]: any }) => {
					if (Object.values(and_match_statement)[0] === null) {
						return false;
					}
					if (Object.values(and_match_statement)[0]["$in"]) {
						if (Object.values(and_match_statement)[0]["$in"]?.length || 0 > 0) {
							return true;
						}
						return false;
					}
					return true;
				});

				properties = await PropertyModel.aggregate([
					{
						$geoNear: {
							...select_queries["$geoNear"],
							key: "search_metrics.location_coordinates",
							query: {
								$and: [
									...AndMatchStatements,
									{
										published: true,
									},
									{
										test: false,
									},
									{
										simulated: false,
									},
									{
										status: "published",
									},
									{
										deleted: false,
									},
								],
							},
						},
					},
					// {
					// 	$match: {
					// 		$and: [
					// 			...AndMatchStatements,
					// 			{
					// 				published: true,
					// 			},
					// 			{
					// 				test: false,
					// 			},
					// 			{
					// 				simulated: false,
					// 			},
					// 			{
					// 				status: "published",
					// 			},
					// 			{
					// 				deleted: false,
					// 			},
					// 		],
					// 	},
					// },
					{
						$project: {
							_id: 1,
							title: 1,
							distance: 1,
							count: { $sum: 1 },
							slug: 1,
							"location.title": 1,
							"search_metrics.location_coordinates": 1,
						},
					},
				]);


				await handleDatabaseConnection(false);
			} catch (error) {
				let label = "HSR Layout";
				let lat = 12.9121181;
				let lon = 77.6445548;
				const callbackUrl = encodeURIComponent(
					`${process.env.PRODUCTION_URL}search?search_type=properties&location=${label},${lat},${lon}&transaction_type=rent&property_category=residential&property_type=Apartment&locale=${context.locale || "en-IN"}`,
				);

				return {
					redirect: {
						destination: `${process.env.PRODUCTION_URL}loading.html?callbackUrl=${callbackUrl}`,
						permanent: false,
					},
				};
			}
		}

		return {
			props: {
				server_session: JSON.parse(JSON.stringify(server_session)),
				properties: JSON.parse(JSON.stringify(properties)),
				ppsfDetails: JSON.parse(JSON.stringify(ppsfDetails)),
				ppsf: [
					{
						location,
					},
					...AndMatchStatementsUnfiltered.map((ams: any, amsIndex: number) =>
						["bhk", "bathroom", "balconies", "seats", "floors"].includes(Object.keys(ams)[0].split(".")[0]) &&
						(ppsf[Object.keys(ams)[0].split(".")[0] as keyof PrePackagedSearchFiltersInterface] || []).length === 7
							? { [Object.keys(ams)[0]]: { $any: [0, 1, 2, 3, 4, 5, 6] } }
							: Object.values(ams)[0] === null
								? { [Object.keys(ams)[0]]: { $any: [0, 1, 2, 3, 4, 5, 6] } }
								: ams,
					).filter((ams: any) => ams !== null),
					{
						published: true,
					},
					{
						test: false,
					},
					{
						simulated: false,
					},
					{
						status: "published",
					},
					{
						deleted: false,
					},
				].map((filter: { [key: string]: any }, filterIndex: number) => {
					const filterKeys = Object.keys(filter);
					const filterValues = Object.values(filter);
					let filterOperation: string;
					let filterValue: any;

					if (filterKeys[0] === "bhk.min" || filterKeys[0] === "bhk.max") {
						if (
							typeof filterValues[0] === "object" &&
							filterValues[0] !== null &&
							Object.keys(filterValues[0]).length > 0
						) {
							filterOperation = Object.keys(filterValues[0])[0];
							filterValue = filterValues[0][filterOperation];
						} else {
							filterOperation = "eq";
							filterValue = filterValues[0];
						}
					} else {
						filterOperation = Object.keys(filterValues[0])[0];
						filterValue =
							filterOperation === "$any"
								? "empty"
								: typeof filterValues[0] === "string" || typeof filterValues[0] === "boolean"
									? filterValues[0]
									: Array.isArray(Object.values(filterValues[0])[0])
										? Object.values(filterValues[0])[0]
										: typeof Object.values(filterValues[0])[0] === "object"
											? Object.values(Object.values(filterValues[0])[0] as any)[0]
											: Object.values(filterValues[0])[0];
					}
					const makeFilterOperationTitle = (operation: string, value: any) => {
						switch (operation) {
							case "$gte":
								return "Should be greater than or equal to";
							case "$lte":
								return "Should be less than or equal to";
							case "$in":
								if (
									(Array.isArray(value) && value.length === 1) ||
									typeof value === "string" ||
									typeof value === "number"
								) {
									return "Should be equal to";
								}
								return "Should be one of";
							case "$any":
								return "Who cares? Can be anything.";
							case "$elemMatch":
								return "Should be one or more of";
							default:
								return "Should be equal to";
						}
					};
					switch (filterKeys[0]) {
						case "location":
							return {
								title: "Location",
								operation: `Should be within a ${(location as any).radius * 1000 < 1000 ? (location as any).radius * 1000 : ((location as any).radius * 1000) / 1000} ${(location as any).radius * 1000 < 1000 ? "m" : "km"} radius of`,
								value: location,
							};
						case "transaction_type":
							return {
								title: "Transaction Type",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 && filterValue.length > 1 ? "and " : ""}${item}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "property_category":
							return {
								title: "Property Category",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "property_type":
							return {
								title: "Property Type",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 && filterValue.length > 1 ? "and " : ""}${item}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "price.min":
							return {
								title: "Minimum Price",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "price.max":
							return {
								title: "Maximum Price",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "bhk.min":
							return {
								title: "Minimum BHK",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value:
									typeof filterValue === "number"
										? `${filterValue} BHK`
										: Array.isArray(filterValue)
											? filterValue.map((v: number) => `${v} BHK`).join(", ")
											: filterValue,
							};
						case "bhk.max":
							return {
								title: "Maximum BHK",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value:
									typeof filterValue === "number"
										? `${filterValue} BHK`
										: Array.isArray(filterValue)
											? filterValue.map((v: number) => `${v} BHK`).join(", ")
											: filterValue,
							};
						case "bathroom.min":
							return {
								title: "Minimum Bathroom",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Bathroom${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Bathroom`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "bathroom.max":
							return {
								title: "Maximum Bathroom",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Bathroom${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Bathroom`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "bathroom.max":
							return {
								title: "Maximum Bathroom",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Bathroom${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Bathroom`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "balconies.min":
							return {
								title: "Minimum Balconies",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Balcony${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Balcony`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "balconies.max":
							return {
								title: "Maximum Balconies",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Balcony${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Balcony`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "area.super_built_up_area.min.ft":
							return {
								title: "Minimum Super Built Up Area (ft)",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "area.super_built_up_area.max.ft":
							return {
								title: "Maximum Super Built Up Area (ft)",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "seats.min":
							return {
								title: "Minimum Seats",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Seat${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Seat`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "seats.max":
							return {
								title: "Maximum Seats",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Seat${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Seat`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "plot_dimensions":
							return {
								title: "Plot Dimensions",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "availability":
							return {
								title: "Availability",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "possession_date":
							return {
								title: "Possession Date",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "available_from":
							return {
								title: "Available From",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "unit_facing":
							return {
								title: "Unit Facing",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map((item: any, pos: number) => `${pos === filterValue.length - 1 ? "and " : ""}${item} Facing`)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Facing`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "land_facing":
							return {
								title: "Land Facing",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map((item: any, pos: number) => `${pos === filterValue.length - 1 ? "and " : ""}${item} Facing`)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Facing`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "floors":
							return {
								title: "Floors",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue
											.sort()
											.map(
												(item: any, pos: number) =>
													`${pos === filterValue.length - 1 ? "and " : ""}${item} Floor${pos > 0 ? "s" : ""}`,
											)
											.join(", ")
									: typeof filterValue === "number"
										? `${filterValue} Floor`
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "furnished":
							return {
								title: "Furnishing",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "amenities":
							return {
								title: "Amenities",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "service_category":
							return {
								title: "Service Category",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "service_type":
							return {
								title: "Service Type",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "service_subtype":
							return {
								title: "Service Subtype",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "listedBy":
							return {
								title: "Listed By",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "business_profile_type":
							return {
								title: "Business Profile Type",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "published":
							return {
								title: "Published",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "status":
							return {
								title: "Status",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "simulated":
							return {
								title: "Simulated",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "test":
							return {
								title: "Test",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						case "deleted":
							return {
								title: "Deleted",
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
						default:
							return {
								title: filterKeys[0],
								operation: makeFilterOperationTitle(filterOperation, filterValue),
								value: Array.isArray(filterValue)
									? filterValue.sort().join(", ")
									: typeof filterValue === "number"
										? filterValue
										: typeof filterValue === "boolean"
											? filterValue
											: `${filterValue}`,
							};
					}
				}),
			},
		};
	},
);

const MainDiv = styled("div")(({ theme }) => ({
	[theme.breakpoints.down("sm")]: {
		paddingTop: "4rem",
	},
	[theme.breakpoints.up("sm")]: {
		paddingTop: "5rem",
	},
}));

const PPSF = ({
	properties,
	ppsfDetails,
	ppsf,
	server_session,
	// session,
	redux_session,
	homePage,
	// lookingFor,
	// is_searching,
	dispatch,
	new_listing_url,
	theme,
	showInactivityDialog,
	profile_context,
	new_business_profile_url,
	// user_location,
	homeLoading,
	homeLocation,
	notification_data,
	newNotification,
	newChatMessage,
	realtimeWebsocket,
	// transaction_type,
	// onBoardingDetails,
	// onBoardingTitle,
	search_filter_state,
	searchanimationsettings,
	search_filters_metrices,
	search_api_response,
	newPropertyData,
	newServiceData,
	// loading,
	bottom_buy_subscription,
	login_flow_global_state,
	chatStates,
	open_post_modal,
	broadcastData,
	feature_discovery_tracker,
}: {
	properties: any;
	ppsfDetails: any;
	ppsf: any;
	server_session: any;
	// session: any;
	redux_session: StateInterface["redux_session"];
	homePage: StateInterface["homePage"];
	// lookingFor: StateInterface["looking_for"];
	// is_searching: StateInterface["is_searching"];
	dispatch: Function;
	new_listing_url: StateInterface["new_listing_url"];
	theme: Theme;
	showInactivityDialog: boolean;
	profile_context: StateInterface["profile_context"];
	new_business_profile_url: StateInterface["new_business_profile_url"];
	// user_location: StateInterface["user_location"];
	homeLoading: StateInterface["home_loading"];
	homeLocation: StateInterface["home_location"];
	notification_data: StateInterface["notifications_page"];
	newNotification?: StateInterface["notification"] | null;
	newChatMessage?: StateInterface["chat_message"] | null;
	realtimeWebsocket: any;
	// transaction_type: StateInterface["transaction"];
	// onBoardingDetails: StateInterface["on_boarding_details"];
	// onBoardingTitle: StateInterface["on_boarding_title"];
	search_filter_state: StateInterface["search_filters_state"];
	searchanimationsettings: StateInterface["search_animation_settings"];
	search_filters_metrices: StateInterface["search_filter_metrices"];
	search_api_response: StateInterface["SeacrhApiResponse"];
	newPropertyData: StateInterface["new_property_data"];
	newServiceData: StateInterface["new_service_data"];
	// loading: StateInterface["loading"];
	bottom_buy_subscription: StateInterface["bottom_subscribe_buy_beegru_points"];
	login_flow_global_state: StateInterface["login_flow_global_state"];
	chatStates: StateInterface["chat_states"];
	open_post_modal: StateInterface["open_post_modal"];
	broadcastData: StateInterface["broadcast_data"];
	feature_discovery_tracker: StateInterface["feature_discovery_tracker"];
}) => {
	const router = useRouter();

	const [initialLoad, setInitialLoad] = React.useState(true);
	const [reduxSessionUpdated, setReduxSessionUpdated] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (server_session && validateClientSession(server_session)) {
			dispatch(updateReduxSessionThunk(server_session));
		}
		setReduxSessionUpdated(true);
		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [server_session]);

	const isCreatePage =
		router.asPath === "/" ||
		router.asPath.includes("utm") ||
		router.asPath.includes("fb") ||
		router.asPath.includes("source") ||
		router.asPath.includes("create_property=true") ||
		router.asPath.includes("create_service=true") ||
		router.asPath.includes("create_ofb=true") ||
		router.asPath.includes("chat=true");
	const mobileNoContain =
		useMediaQuery(theme.breakpoints.down("sm")) && !isCreatePage && !initialLoad && router.asPath.includes("/search");
	React.useEffect(() => {
		setInitialLoad(false);
	}, []);

	const PPSFLocation = ppsf.find((data: any) => data.title === "Location")?.value;

	const metaTitle = ppsfDetails.find((item: any) => item.key === "Meta Title")?.value || "";
	const metaDescription = ppsfDetails.find((item: any) => item.key === "Meta Description")?.value || "";

	const PageTitle = ppsfDetails.find((item: any) => item.key === "Page Title (H1 Tag)")?.value || "";
	const PageSubtitle =
		ppsfDetails.find((item: any) => item.key === "Page Subtitle / Description (H2 Tag)")?.value || "";
	const getPPSFUrl = (ppsf: any[], locale: string = "en-IN") => {
		const queryParams: Record<string, string> = {};
		const title_to_exclude = ["Published", "Test", "Simulated", "Status", "Deleted"];

		// Extract BHK values first
		let bhkMin: number | null = null;
		let bhkMax: number | null = null;

		ppsf.forEach((item: any) => {
			if (item.title === "Minimum BHK" || item.title === "BHK") {
				const match = String(item.value).match(/(\d+)/);
				if (match) bhkMin = parseInt(match[1]);
			}
			if (item.title === "Maximum BHK" || item.title === "BHK") {
				const match = String(item.value).match(/(\d+)/);
				if (match) bhkMax = parseInt(match[1]);
			}
			if (item.title === "BHK Range") {
				const matches = String(item.value).match(/(\d+)/g);
				if (matches && matches.length >= 2) {
					bhkMin = parseInt(matches[0]);
					bhkMax = parseInt(matches[1]);
				}
			}
		});

		// Add bedrooms_variant_2 if BHK values exist
		if (bhkMin !== null && bhkMax !== null) {
			if (bhkMin === bhkMax) {
				queryParams["bedrooms_variant_2"] = String(bhkMin);
			} else {
				const bhkRange: any = [];
				for (let i = bhkMin; i <= bhkMax; i++) {
					bhkRange.push(i);
				}
				queryParams["bedrooms_variant_2"] = bhkRange.join(",");
			}
		} else if (bhkMin !== null) {
			queryParams["bedrooms_variant_2"] = String(bhkMin);
		} else if (bhkMax !== null) {
			queryParams["bedrooms_variant_2"] = String(bhkMax);
		}

		ppsf.forEach((item: any) => {
			if (
				item.title &&
				!title_to_exclude.includes(item.title) &&
				!["Minimum BHK", "Maximum BHK", "BHK", "BHK Range"].includes(item.title) &&
				item.value !== undefined &&
				item.value !== null &&
				item.value !== "empty" &&
				item.value !== "" &&
				!(typeof item.value === "object" && Object.keys(item.value).length === 0)
			) {
				const key = item.title.toLowerCase().replace(/\s+/g, "_");
				if (key === "location" && typeof item.value === "object" && item.value.title && item.value.coordinates) {
					queryParams[key] = `${item.value.title},${item.value.coordinates[0]},${item.value.coordinates[1]}`;
				} else if (key === "property_type") {
					if (Array.isArray(item.value)) {
						queryParams[key] = String(item.value[0]);
					} else if (typeof item.value === "string" && item.value.includes(",")) {
						queryParams[key] = item.value.split(",")[0].trim();
					} else {
						queryParams[key] = String(item.value);
					}
				} else {
					queryParams[key] = typeof item.value === "object" ? JSON.stringify(item.value) : String(item.value);
				}
			}
		});

		const queryString = new URLSearchParams(queryParams).toString();
		return `/search?search_type=properties&${queryString}&locale=${locale}`;
	};
	const ppsfRedirectURL = getPPSFUrl(ppsf, router.locale);
	const [URLGenerated, setURLGenerated] = React.useState<boolean>(false);
	/*

	* Intial setting of search filters from PPSF URL

	*/

	React.useEffect(() => {
		if (ppsfRedirectURL && !URLGenerated) {
			const queryString = ppsfRedirectURL.split("?")[1] || "";
			const params = new URLSearchParams(queryString);

			// Directly dispatch all params - no special BHK handling needed
			params.forEach((value, key) => {
				RouterQuerySearchFilters(key, value, dispatch);
			});

			setURLGenerated(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ppsfRedirectURL]);

	return (
		<React.Fragment>
			<Layout
				realtime_websocket={realtimeWebsocket}
				title={metaTitle ? metaTitle : undefined}
				description={metaDescription ? metaDescription : undefined}
				showChatFab
				chatStates={chatStates ? chatStates : chat_states}
				new_chat_message={newChatMessage ? newChatMessage : null}
				noContain={mobileNoContain ? [1] : [0]}
				session={redux_session}
				redux_session_updated={reduxSessionUpdated}
				showInactivityDialog={showInactivityDialog}
				theme={theme}
				dispatch={dispatch}
				profile_context={profile_context}
				new_business_profile_url={new_business_profile_url ? new_business_profile_url : ""}
				new_listing_url={new_listing_url ? new_listing_url : ""}
				notifications={notification_data ? notification_data : notifications_page}
				new_notification={newNotification ? newNotification : null}
				newPropertyData={newPropertyData}
				newServiceData={newServiceData}
				search_filter_state={search_filter_state}
				searchanimationsettings={searchanimationsettings}
				// searchLocation={searchLocation}
				bottom_buy_subscription={bottom_buy_subscription ? bottom_buy_subscription : bottom_subscribe_buy_beegru_points}
				login_flow_global_state={login_flow_global_state}
				open_post_modal={open_post_modal}
				broadcastData={broadcastData}
				broadcastFeatureDiscoveryTracker={
					feature_discovery_tracker
						? feature_discovery_tracker.broadcast
						: {
								viewed: false,
								viewed_at: "",
								skipped: false,
							}
				}
				ppsfsearchLocation={PPSFLocation}
				ppsf_id={ppsfDetails.find((item: any) => item.key === "PPSF ID")?.value || ""}
				ppsf_transaction_type={String(ppsf.find((item: any) => item.title === "Transaction Type")?.value || "")}
			>
				<MainDiv>
					{router.query.table === "yes" ? (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								justifyContent: "flex-start",
								margin: "4rem 0rem 1rem 0rem",
								padding: "0 1rem",
								gap: "1rem",
							}}
						>
							<h1 style={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>{`Pre-Packaged Search Filters: Test Output`}</h1>
							<h3 style={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>{`PPSF Details =>`}</h3>
							<table style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
								<thead style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
									<tr style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>#</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Field Name</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Field Value</th>
									</tr>
								</thead>
								<tbody>
									{ppsfDetails.map((ppsfDetailsItem: any, ppsfDetailsItemIndex: number) => (
										<tr key={ppsfDetailsItemIndex}>
											<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
												{ppsfDetailsItemIndex + 1}
											</td>
											<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{ppsfDetailsItem.key}</td>
											{ppsfDetailsItem.key === "Created By" ? (
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
													<a
														href={`${process.env.PRODUCTION_URL}users/${ppsfDetailsItem.value._id}`}
														target="_blank"
														rel="noopener noreferrer"
														title={`${ppsfDetailsItem.value.first_name} ${ppsfDetailsItem.value.last_name}`}
													>
														{`[${ppsfDetailsItem.value._id}] => ${ppsfDetailsItem.value.first_name} ${ppsfDetailsItem.value.last_name}`}
													</a>
												</td>
											) : (
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
													{ppsfDetailsItem.value}
												</td>
											)}
										</tr>
									))}
								</tbody>
							</table>
							<h3 style={{ margin: "0 0 0 0", padding: "0 0 0 0" }}>{`The following filters were applied =>`}</h3>
							<table style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
								<thead style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
									<tr style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>#</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Filter Name</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Filter Operation</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Filter Value</th>
									</tr>
								</thead>
								<tbody>
									{ppsf.map((ppsfItem: any, ppsfItemIndex: number) => {
										return (
											<tr
												key={ppsfItemIndex}
												style={{ border: "1px solid black", borderCollapse: "collapse" }}
											>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{ppsfItemIndex + 1}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{ppsfItem.title}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{ppsfItem.operation}</td>
												{ppsfItem.title === "Location" ? (
													<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
														{
															<a
																href={`https://www.google.com/maps/search/?api=1&query=${ppsfItem.value.coordinates[1]},${ppsfItem.value.coordinates[0]}`}
																target="_blank"
																rel="noopener noreferrer"
																title={ppsfItem.value.title}
															>{`[${ppsfItem.value.coordinates[1]}, ${ppsfItem.value.coordinates[0]}] => ${ppsfItem.value.title}`}</a>
														}
													</td>
												) : (
													<td
														style={{ border: "1px solid black", borderCollapse: "collapse" }}
													>{`${ppsfItem.value}`}</td>
												)}
											</tr>
										);
									})}
								</tbody>
							</table>
							<h3
								style={{ margin: "0 0 0 0", padding: "0 0 0 0" }}
							>{`Found ${properties.length} properties matching the above criteria =>`}</h3>
							<table style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
								<thead style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
									<tr style={{ width: "100%", border: "1px solid black", borderCollapse: "collapse" }}>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>#</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>ID</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Title</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Location</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Distance</th>
										<th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Link</th>
									</tr>
								</thead>
								<tbody>
									{properties.map((property: any, propertyIndex: number) => {
										return (
											<tr
												key={propertyIndex}
												style={{ border: "1px solid black", borderCollapse: "collapse" }}
											>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{propertyIndex + 1}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{property._id}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{property.title}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
													<a
														href={`https://www.google.com/maps/search/?api=1&query=${property.search_metrics.location_coordinates[1]},${property.search_metrics.location_coordinates[0]}`}
														target="_blank"
														rel="noopener noreferrer"
													>
														{property.location.title}
													</a>
												</td>
												<td
													style={{ border: "1px solid black", borderCollapse: "collapse" }}
												>{`${(property.distance > 1000 ? property.distance / 1000 : property.distance).toFixed(1)}${property.distance > 1000 ? " km" : " m"}`}</td>
												<td style={{ border: "1px solid black", borderCollapse: "collapse" }}>
													<a
														href={`${process.env.PRODUCTION_URL || ""}properties/${property.slug}`}
														title={property.title}
														target="_blank"
														rel="noopener noreferrer"
													>
														{property.title}
													</a>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					) : (
						<div style={{ minHeight: "600px" }}>
							{initialLoad ? (
								<SearchDesktopLayoutSkeleton />
							) : (
								<>
									<FilterComponents
										total_property_ids={properties.map((p: any) => p._id)}
										session={redux_session}
										search_filter_state={search_filter_state}
										profile_context={profile_context}
										CollectionName="properties"
										searchLocation={PPSFLocation}
										dispatch={dispatch}
										initialLoad={initialLoad}
										searchanimationsettings={searchanimationsettings}
										login_flow_global_state={login_flow_global_state}
										pageTitle={PageTitle}
										pageSubtitle={PageSubtitle}
									/>
								</>
							)}
						</div>
					)}
				</MainDiv>
			</Layout>
		</React.Fragment>
	);
};

export default connect(
	({
		globalState: {
			homePage,
			// looking_for,
			// is_searching,
			profile_context,
			new_listing_url,
			new_business_profile_url,
			// user_location,
			home_loading,
			home_location,
			notifications_page,
			// transaction,
			// on_boarding_details,
			// on_boarding_title,
			redux_session,
			search_filters_state,
			search_animation_settings,
			search_filter_metrices,
			SeacrhApiResponse,
			new_property_data,
			new_service_data,
			// loading,
			bottom_subscribe_buy_beegru_points,
			login_flow_global_state,
			chat_states,
			open_post_modal,
			broadcast_data,
			feature_discovery_tracker,
		},
	}: {
		globalState: {
			homePage: StateInterface["homePage"];
			// // looking_for: StateInterface["looking_for"];
			// is_searching: StateInterface["is_searching"];
			profile_context: StateInterface["profile_context"];
			new_listing_url: StateInterface["new_listing_url"];
			new_business_profile_url: StateInterface["new_business_profile_url"];
			// user_location: StateInterface["user_location"];
			home_loading: StateInterface["home_loading"];
			home_location: StateInterface["home_location"];
			notifications_page: StateInterface["notifications_page"];
			// transaction: StateInterface["transaction"];
			// on_boarding_details: StateInterface["on_boarding_details"];
			// on_boarding_title: StateInterface["on_boarding_title"];
			redux_session: StateInterface["redux_session"];
			search_filters_state: StateInterface["search_filters_state"];
			search_animation_settings: StateInterface["search_animation_settings"];
			search_filter_metrices: StateInterface["search_filter_metrices"];
			SeacrhApiResponse: StateInterface["SeacrhApiResponse"];
			new_property_data: StateInterface["new_property_data"];
			new_service_data: StateInterface["new_service_data"];
			loading: StateInterface["loading"];
			bottom_subscribe_buy_beegru_points: StateInterface["bottom_subscribe_buy_beegru_points"];
			login_flow_global_state: StateInterface["login_flow_global_state"];
			chat_states: StateInterface["chat_states"];
			open_post_modal: StateInterface["open_post_modal"];
			broadcast_data: StateInterface["broadcast_data"];
			feature_discovery_tracker: StateInterface["feature_discovery_tracker"];
		};
	}) => ({
		homePage: homePage,
		// lookingFor: looking_for,
		// is_searching: is_searching,
		profile_context: profile_context,
		new_listing_url: new_listing_url,
		new_business_profile_url: new_business_profile_url,
		// user_location: user_location,
		homeLoading: home_loading,
		homeLocation: home_location,
		notification_data: notifications_page,
		// transaction_type: transaction,
		// onBoardingDetails: on_boarding_details,
		// onBoardingTitle: on_boarding_title,
		redux_session: redux_session,
		search_filter_state: search_filters_state,
		searchanimationsettings: search_animation_settings,
		search_filters_metrices: search_filter_metrices,
		search_api_response: SeacrhApiResponse,
		newPropertyData: new_property_data,
		newServiceData: new_service_data,
		// loading: loading,
		bottom_buy_subscription: bottom_subscribe_buy_beegru_points,
		login_flow_global_state: login_flow_global_state,
		chatStates: chat_states,
		open_post_modal: open_post_modal,
		broadcastData: broadcast_data,
		feature_discovery_tracker: feature_discovery_tracker,
	}),
)(PPSF);
